'use client';

import { Turnstile } from '@marsidev/react-turnstile';

type ContactTurnstileProps = {
  resetKey: number;
  onToken: (token: string) => void;
  onExpire: () => void;
  onError: () => void;
};

export function ContactTurnstile({
  resetKey,
  onToken,
  onExpire,
  onError,
}: ContactTurnstileProps) {
  const siteKey = import.meta.env.VITE_TURNSTILE_SITE_KEY;

  if (!siteKey) {
    return (
      <p className="text-muted-foreground font-mono text-sm">
        Verification is unavailable in this build. Retry later or use direct
        email.
      </p>
    );
  }

  return (
    <Turnstile
      key={resetKey}
      siteKey={siteKey}
      options={{
        action: 'contact',
        theme: 'light',
      }}
      onSuccess={onToken}
      onExpire={onExpire}
      onError={onError}
    />
  );
}
